module.exports = __webpack_public_path__ + "static/dryvan-e6dd7cae52f1564a549153342a2cd4a5.svg";